import React from 'react'
import ItemsMenu from 'components/organisms/ItemsMenu'

function CaseLevelNavbar(): JSX.Element {
  return <ItemsMenu />
}

export default CaseLevelNavbar
